import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=4bd1774b&"
import script from "./NoContent.vue?vue&type=script&lang=js&"
export * from "./NoContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports